import React from "react";
import { Check } from "lucide-react";
import VideoPreview from "../components/VideoPreview";
import { MARKETING_MEDIA } from "../../../config/marketing/media";
import { Button } from "../../../components/common/button";
import Section from "../../../components/layout/marketing/Section";
import { HERO_START_TRIAL_CTA } from "../../../config/marketing/hero";
import { assets } from "../../../assets/assets";

export default function HeroSection() {
    const handleStartFreeTrial = () => {
        const url = HERO_START_TRIAL_CTA;
        window.location.href = url;
    };

    return (
        <Section className="relative overflow-hidden bg-bg-page py-0" id="about">
            {/* Subtle green ambient glow */}
            <div
                aria-hidden
                className="
                    pointer-events-none
                    absolute
                    -left-20
                    top-1/2
                    -translate-y-1/2
                    h-[600px]
                    w-[600px]
                    rounded-full
                    bg-primary/5
                    blur-[120px]
                "
            />

            <div className="relative grid items-center justify-center gap-16 lg:grid-cols-2 md:py-6">
                {/* Left: Content */}
                <div className="w-full">
                    <h1 className="text-5xl lg:text-7xl font-semibold tracking-tight md:leading-tight text-text-primary text-center md:text-left">
                        Instant Clinic Website. Managed{" "}
                        <span className="bg-brand-gradient bg-clip-text text-transparent">on WhatsApp</span>
                    </h1>

                    <p className="mt-3 md:mt-6 max-w-xl text-lg lg:text-xl tracking-tight md:leading-relaxed text-black text-center md:text-left">
                        Let patients book appointments directly via web or chat. No setup. No new app. Just your clinic,
                        organised.
                    </p>

                    <div className="mt-12 flex flex-col gap-4 md:flex-row md:items-center">
                        <Button size="lg" variant="primaryGlow" onClick={handleStartFreeTrial}>
                            Start Free Trial
                        </Button>
                    </div>

                    <div className="mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-text-muted justify-center md:justify-start">
                        <Check className="h-4 w-4 text-primary" />
                        <span>No credit card required</span>
                        <Check className="h-4 w-4 text-primary" />
                        <span>Free 7-day trial</span>
                    </div>
                </div>

                {/* Right: Video */}
                <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
                    <VideoPreview src={MARKETING_MEDIA.heroVideo.src} poster={assets.hero_thumbnail} />
                </div>
            </div>
        </Section>
    );
}
